import { render, staticRenderFns } from "./GitConfig.vue?vue&type=template&id=cc638994&scoped=true"
import script from "./GitConfig.vue?vue&type=script&lang=js"
export * from "./GitConfig.vue?vue&type=script&lang=js"
import style0 from "./GitConfig.vue?vue&type=style&index=0&id=cc638994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc638994",
  null
  
)

export default component.exports